import { ZoomIcon } from "#components/ui/ZoomIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const zoomManifest: IntegrationManifest = {
    key: "zoom",
    displayName: "Zoom",
    nameKey: "channels.zoom",
    descriptionKey: "zoomDescription",
    trayDescriptionKey: "composerTrayDescriptions.zoom",
    cardDescriptionKey: "connectIntegration.descriptions.zoom",
    connectedContentKeys: ["zoomContent"],
    brandColor: "#0B5CFF",
    iconUrl: IconAssets.Zoom,
    iconUrlAlt: IconAssets.ZoomAlt,
    glyph: ZoomIcon,
    channelType: "UserZoomMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
